export default __webpack_public_path__ + "static/media/ablalogosvg.e94983a6.svg";